module.exports = require("./hi");